<template>
    <div>
      <NavbarSas />
      <div class="main-content">
        <router-view></router-view>
      </div>
    </div>
  </template>
  
  <script>
  import NavbarSas from './navbarSas.vue';
  
  export default {
    name: 'App',
    components: {
        NavbarSas,
    },
  };
  </script>